<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import FollowUp from 'dashboard/components-next/FollowUp/FollowUp.vue';

defineProps({
  contactId: { type: Number, required: true },
  hasConversation: { type: Boolean, default: false },
  email: { type: String, default: '' },
  nextFollowUpAt: { type: String, default: '' },
  followUpNote: { type: String, default: '' },
  meetingRequired: { type: Boolean, default: false },
  meetingProvider: { type: String, default: '' },
  meetingUrl: { type: String, default: '' },
  meetingReference: { type: String, default: '' },
  followUpType: { type: String, default: '' },
  meetingLocation: { type: String, default: '' },
  followUpTeamId: { type: [Number, String], default: '' },
  assignee: { type: Object, default: null },
  ccEmails: { type: Array, default: () => [] },
});

const emit = defineEmits(['saved']);

const { t } = useI18n();
const dialogRef = ref(null);

const handleSaved = () => emit('saved');

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('FOLLOW_UP.TITLE')"
    :show-confirm-button="false"
    :cancel-button-label="t('FOLLOW_UP.ACTIONS.CLOSE')"
  >
    <FollowUp
      mode="full"
      :contact-id="contactId"
      :has-conversation="hasConversation"
      :email="email"
      :next-follow-up-at="nextFollowUpAt"
      :follow-up-note="followUpNote"
      :meeting-required="meetingRequired"
      :meeting-provider="meetingProvider"
      :meeting-url="meetingUrl"
      :meeting-reference="meetingReference"
      :follow-up-type="followUpType"
      :meeting-location="meetingLocation"
      :follow-up-team-id="followUpTeamId"
      :assignee="assignee"
      :cc-emails="ccEmails"
      @saved="handleSaved"
    />
  </Dialog>
</template>
